/**
 * Tracks OpenIM's post-login server sync (`OnSyncServerFinish`), matching Android
 * `TgImOpenImBootstrap.isOpenImServerSyncFinished` / `runWhenServerSyncFinishedForSend`.
 *
 * `getAllConversationList` and SDK message creates often return empty / hang until this fires.
 */

const DEFAULT_WAIT_MS = 30_000;

let serverSyncFinished = false;
const waiters = new Set<() => void>();

export function isOpenImServerSyncFinished(): boolean {
  return serverSyncFinished;
}

/** Call when starting a new OpenIM login so a previous session's finish flag is not reused. */
export function resetOpenImServerSyncState(): void {
  serverSyncFinished = false;
}

export function markOpenImServerSyncFinished(): void {
  serverSyncFinished = true;
  waiters.forEach((resolve) => resolve());
  waiters.clear();
}

/**
 * Resolves when `OnSyncServerFinish` / `OnSyncServerFailed` has been observed, or after
 * `timeoutMs` (Android also unblocks UI after a timeout so the app does not hang forever).
 */
export function waitForOpenImServerSync(timeoutMs = DEFAULT_WAIT_MS): Promise<void> {
  if (serverSyncFinished) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      waiters.delete(finish);
      resolve();
    };
    const timer = window.setTimeout(finish, timeoutMs);
    waiters.add(finish);
  });
}
